// extracted by mini-css-extract-plugin
export var option = "_c4-0";
export var optionCard = "_c4-f";
export var optionContent = "_c4-g";
export var optionIcon = "_c4-i";
export var optionIconBox = "_c4-h";
export var optionLabel = "_c4-j";
export var optionPill = "_c4-m";
export var optionPillBadge = "_c4-p";
export var optionPillIcon = "_c4-n";
export var optionPillLabel = "_c4-o";
export var optionRadio = "_c4-k";
export var optionRadioInner = "_c4-l";
export var optionReveal = "_c4-2";
export var optionRevealDelay0 = "_c4-3";
export var optionRevealDelay1 = "_c4-4";
export var optionRevealDelay10 = "_c4-d";
export var optionRevealDelay11 = "_c4-e";
export var optionRevealDelay2 = "_c4-5";
export var optionRevealDelay3 = "_c4-6";
export var optionRevealDelay4 = "_c4-7";
export var optionRevealDelay5 = "_c4-8";
export var optionRevealDelay6 = "_c4-9";
export var optionRevealDelay7 = "_c4-a";
export var optionRevealDelay8 = "_c4-b";
export var optionRevealDelay9 = "_c4-c";
export var optionSelected = "_c4-1";